import axios from "axios";
import { Global } from "../Variables/Global";
import { toast } from "react-toastify";
import Cookies from "js-cookie";

// var emailregx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
var emailregx =
  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
const strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})");
const offset = new Date().getTimezoneOffset();
// const token = Cookies.get("CustomerToken");

export function LoginValidation(email, password) {
  if (email === "" || password === "") {
    toast.error("please fill required fields");
    return false;
  } else if (!emailregx.test(email)) {
    toast.error("Bad email format");
    return false;
  } else {
    return true;
  }
}

export function ResetPasswordValidation(password, confirmPassword) {
  if (password === "" || confirmPassword === "") {
    toast.error("Please fill required fields");
  } else if (password !== confirmPassword) {
    toast.error("New Password Must match the confirm Password");
  } else {
    var strongPasswordRegex = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})"
    );
    var validpassword = strongPasswordRegex.test(password);
    if (!validpassword) {
      toast.error(
        "Password must be minimum 8 characters consisting of numbers, uppercase and lowercase letters and Symbols"
      );
      return false;
    } else {
      return true;
    }
  }
}

export function RegisterValidation(
  email,
  password,
  firstName,
  lastName,
  confirmPassword
) {
  if (
    email === "" ||
    password === "" ||
    firstName === "" ||
    lastName === "" ||
    confirmPassword === ""
  ) {
    toast.error("please fill required fields");
    return false;
  } else if (!emailregx.test(email)) {
    toast.error("Bad email format");
  } else if (!strongRegex.test(password)) {
    toast.error(
      "Password must include  8 Characters Minimum,1 capital letter, 1 number. "
    );
    return false;
  } else {
    if (password !== confirmPassword) {
      toast.error("passwords do not match1");
      return false;
    } else {
      return true;
    }
  }
}

export const UserRegistration = async (email, password, firstName, lastName) =>
  await fetch(Global.API_URL + "Customer/CustomerRegistration", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": Global.API_URL,
    },
    body: JSON.stringify({
      Email: email,
      Password: password,
      FirstName: firstName,
      LastName: lastName,
    }),
  }).then((response) => {
    if (response.ok) {
      return response.json();
    }
    return response.text().then((text) => {
      throw new Error(text);
    });
  });

export const UserLogin = async (email, password) =>
  await fetch(Global.API_URL + "Customer/CustomerLogin", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": Global.API_URL,
    },
    body: JSON.stringify({
      Email: email,
      Password: password,
      registrationTypeId: 1,
      firstName: "",
      lastName: "",
      profilePicture: "",
    }),
  }).then((Response) => {
    if (Response.ok) {
      return Response.json();
    }
    return Response.text().then((text) => {
      throw new Error(text);
    });
  });

export const ConfirmEmail = async (ID, code) =>
  await fetch(Global.API_URL + "Customer/EmailConfirmation/" + ID, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": Global.API_URL,
    },
    body: JSON.stringify({
      code: code,
    }),
  }).then((Response) => {
    if (Response.ok) {
      return Response.json();
    }
    return Response.text().then((text) => {
      throw new Error(text);
    });
  });

export const ResetPassword = async (email, old, password) =>
  await fetch(Global.API_URL + "Customer/CustomerResetPassword", {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": Global.API_URL,
    },
    body: JSON.stringify({
      email: email,
      oldPassword: old,
      newPassword: password,
    }),
  });

export const ForgretPassword = async (email) =>
  await fetch(Global.API_URL + "Customer/CustomerForgetPassword", {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": Global.API_URL,
    },
    body: JSON.stringify({
      Email: email,
    }),
  });

export const GetAddress = async (CustomerId, token) =>
  await fetch(
    Global.API_URL +
      "AddressBook/GetOrderAddressBookByAddressType/Home/" +
      CustomerId,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  ).then((response) => {
    if (response.ok) {
      return response.json();
    }
  });

export const GetCountriesWithCities = async (token) =>
  await fetch(Global.API_URL + "Country/GetAllCountriesWithCities", {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    }
  });

export const getSliders = async (sliderId) =>
  await fetch(Global.API_URL + "Slider/GetSlidesBySliderId/" + sliderId, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  }).then((res) => {
    if (res.ok) {
      return res.json();
    }
  });

// export const getWidgets = async (WidgetId) => await fetch(Global.API_URL + "Widgets/GetAssignedCategories/" + WidgetId);

export const GetAllProducts = async (currentPage, LIMIT) =>
  await fetch(Global.API_URL + "Products/GetAllProduct", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": Global.API_URL,
    },
    body: JSON.stringify({
      pageId: currentPage,
      count: LIMIT,
      Offset: -120,
    }),
  }).then((Response) => {
    if (Response.ok) return Response.json();
    else throw Error("Did Not Receive expected data");
  });

export const getProductsBySearchTerm = async (Term, index, LIMIT) =>
  await fetch(Global.API_URL + "Products/GetSearchedProducts", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": Global.API_URL,
    },
    body: JSON.stringify({
      Term: Term,
      pageId: index,
      count: LIMIT,
      offset: offset,
      attributes: [],
      categories: [],
      prices: [],
    }),
  }).then((Response) => {
    if (Response.ok) return Response.json();
    else throw Error("Did Not Receive expected data");
  });

export const getProductsByCategoryId = async (categoryId, groupId, pageId = 1, count = 9) =>
  await fetch(Global.API_URL + "Products/GetProductsByCategoryId", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      categoryId: categoryId,
      pageId: pageId,
      count: count,
      offset: offset,
      attributes: [],
      categories: [],
      prices: [],
      groupId: groupId,
      countryId: 125,
    }),
  }).then((Response) => {
    if (Response.ok) return Response.json();
    else throw Error("Did Not Receive expected data");
  });

export const GetProductVariationByVariationId = async (ProductVariationId) =>
  fetch(
    Global.API_URL +
      "Products/GetProductVariationByVariationId/" +
      ProductVariationId +
      "/" +
      offset,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": Global.API_URL,
      },
    }
  ).then((resp) => {
    if (resp.ok) {
      return resp.json();
    }
  });

export const getCategories = async () =>
  await fetch(Global.API_URL + "Category/GetCategories", {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  }).then((Response) => {
    if (Response.ok) return Response.json();
    else throw Error("Did Not Receive expected data");
  });

export const AddItemToWishList = async (
  WishlistId,
  ProductId,
  ProductVariationId,
  token
) =>
  await fetch(Global.API_URL + "Wishlist/AddItemToWishlist", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": Global.API_URL,
    },
    body: JSON.stringify({
      WishlistId: WishlistId,
      ProductId: ProductId,
      VariationId: ProductVariationId,
    }),
  });

export const RemoveItemFromWishList = async (ProductId, WishlistId,token) =>
  await fetch(
    Global.API_URL +
      "Wishlist/RemoveItemFromWishlist" +
      "/" +
      ProductId +
      "/" +
      WishlistId,
    {
      method: "Delete",
      headers: {
        Accept: "application/json",
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": Global.API_URL,
      },
    }
  );

export const GetWishListItems = async (WishlistId, groupId,token) =>
  await fetch(
    Global.API_URL +
      "Wishlist/GetWishistItems/" +
      WishlistId +
      "/" +
      offset +
      "/" +
      125 +
      "/" +
      groupId,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  ).then((response) => {
    if (response.ok) {
      return response.json();
    }
  });

export const AddItemToCart = async (
  CartId,
  ProductId,
  ProductVariationId,
  quantity,
  token
) =>
  await fetch(Global.API_URL + "Cart/AddItemToCart", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": Global.API_URL,
    },
    body: JSON.stringify({
      CartId: CartId,
      ProductId: ProductId,
      VariationId: ProductVariationId,
      Quantity: quantity,
    }),
  });

export const RemoveItemFromCart = async (ProductVariationId, CartId, token) =>
  await fetch(
    Global.API_URL +
      "Cart/RemoveItemFromCart" +
      "/" +
      ProductVariationId +
      "/" +
      CartId,
    {
      method: "Delete",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": Global.API_URL,
      },
    }
  );

export const GetCartItems = async (CartId, groupId, token) =>
  fetch(
    Global.API_URL +
      "Cart/GetCartItems/" +
      CartId +
      "/" +
      offset +
      "/" +
      125 +
      "/" +
      groupId,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  ).then((response) => {
    if (response.ok) {
      return response.json();
    }
  });

export const getCrossSell = async (ProductId, groupId) =>
  await fetch(
    Global.API_URL +
      "Products/GetCrossSells/" +
      ProductId +
      "/" +
      offset +
      "/" +
      125 +
      "/" +
      groupId,
    {
      method: "Get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": Global.API_URL,
      },
    }
  ).then((resp) => {
    if (resp.ok) {
      return resp.json();
    }
  });

export const GetUpSell = async (ProductId, groupId) =>
  await fetch(
    Global.API_URL +
      "Products/GetUpSells/" +
      ProductId +
      "/" +
      offset +
      "/" +
      125 +
      "/" +
      groupId,
    {
      method: "Get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": Global.API_URL,
      },
    }
  ).then((resp) => {
    if (resp.ok) {
      return resp.json();
    }
  });

export const GetOrderDetails = async (id, token) =>
  await fetch(Global.API_URL + "Order/GetOrderDetailsByCustomerId/" + id, {
    method: "Get",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": Global.API_URL,
    },
  }).then((resp) => {
    if (resp.ok) {
      return resp.json();
    }
  });

export const GetOrderAddressBookByAddressType = (key, CustomerId, token) =>
  fetch(
    Global.API_URL +
      "AddressBook/GetOrderAddressBookByAddressType/" +
      key +
      "/" +
      CustomerId,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  ).then((response) => {
    if (response.ok) {
      return response.json();
    }
  });
